(function (module) {
    module.service("mlDataService", [
        "$http",
        "$log",
        "dtpChartService",
        "$q",
        function (
            this: $TSFixMe,
            $http: ng.IHttpService,
            $log: ng.ILogService,
            dtpChartService: $TSFixMe,
            $q: ng.IQService
        ) {
            var service = this;

            service.getRollingForecasts = (forecastStartDate: $TSFixMe, forecastEndDate: $TSFixMe, skus: $TSFixMe) => {
                const productCodes = skus.map((s: $TSFixMe) => s.oracleIndex);
                return $http({
                    method: "POST",
                    url: "api/ml/topline/rolling-forecast",
                    data: {
                        forecastStartDate,
                        forecastEndDate,
                        productCodes
                    }
                }).then((response: $TSFixMe) => mapResult(response.data, skus));
            };

            service.getRollingForecastWithPharmShare = (
                productCodes: $TSFixMe,
                historicalEndStartDate: $TSFixMe,
                forecastStartDate: $TSFixMe,
                forecastEndDate: $TSFixMe
            ) => {
                var startDate = moment.utc(historicalEndStartDate).add(-12, "months").startOf("month").toDate();
                var endDate = historicalEndStartDate;

                return $q
                    .all([
                        $http.post("api/ml/topline/rolling-forecast", {
                            forecastStartDate,
                            forecastEndDate,
                            productCodes
                        }),
                        $http({
                            method: "POST",
                            url: "api/ims/pharmacy-market/share",
                            data: {
                                productCodes,
                                startDate,
                                endDate
                            }
                        })
                    ])
                    .then((responses: $TSFixMe) => {
                        let volumeSum = null;
                        for (const sku of responses[0].data) {
                            volumeSum = sumToArray(volumeSum, sku.volume);
                        }

                        return {
                            productVolume: volumeSum,
                            share: responses[1].data
                        };
                    });
            };

            service.getProductData = (productCodes: $TSFixMe) =>
                $http({
                    method: "GET",
                    url: "api/ml/product-data",
                    params: {
                        productCodes
                    }
                }).then((response: $TSFixMe) => response.data);

            function sumToArray(resultArray: $TSFixMe, inputArray: $TSFixMe) {
                if (angular.isUndefinedOrNull(resultArray)) return inputArray.slice();
                for (let i = 0; i < resultArray.length; i++) {
                    if (!angular.isUndefinedOrNull(inputArray[i])) {
                        resultArray[i] += inputArray[i];
                    }
                }
                return resultArray;
            }

            function mapResult(rollingForecasts: $TSFixMe, skus: $TSFixMe) {
                let volumeSum = null;
                let valueSum = null;

                let skusResult = [];

                let missingRollingForecast = false;

                for (const sku of skus) {
                    let rollingForecast = _.find(rollingForecasts, (rf: $TSFixMe) => rf.productCode == sku.oracleIndex);

                    if (angular.isUndefinedOrNull(rollingForecast)) {
                        missingRollingForecast = true;
                        rollingForecast = {
                            volume: _.times(sku.forecast.price.length, _.constant(null))
                        };
                    }

                    const value = [];
                    for (let i = 0; i < rollingForecast.volume.length; i++) {
                        value[i] = rollingForecast.volume[i] * sku.forecast.price[i];
                    }
                    volumeSum = sumToArray(volumeSum, rollingForecast.volume);
                    valueSum = sumToArray(valueSum, value);

                    skusResult.push({
                        volume: rollingForecast.volume,
                        value,
                        productCode: rollingForecast.productCode,
                        name: sku.name
                    });
                }

                return {
                    brandVolume: volumeSum,
                    brandValue: valueSum,
                    skus: skusResult,
                    missingRollingForecast
                };
            }

            service.getPrices = (productCodes: $TSFixMe) => {
                return $http({
                    method: "GET",
                    url: "api/ml/price",
                    params: {
                        productCodes
                    }
                }).then((response: $TSFixMe) => {
                    var dict = {};
                    for (const item of response.data) {
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        dict[item.productCode] = item.price;
                    }
                    return dict;
                });
            };
        }
    ]);
})(angular.module("topline.modules"));
